import { parseJsonString } from 'pano-utils';
import type { PanoMultires } from '@types';

export function parseMultires(multiresString: string) {
  return parseJsonString(multiresString) as PanoMultires;
}
